import React from "react";
import { Link } from "react-router-dom";
import LegalPage, { Bullets, Section } from "../components/legal/LegalPage";

/**
 * Google Play requires a publicly reachable page describing how to request
 * account deletion, reachable without signing in (#157). It also serves users
 * whose account is still pending verification and so cannot sign in at all.
 */
const DeleteAccount = () => (
	<LegalPage title="Delete Your Account" updated="25 August 2026">
		<Section heading="Deleting from the app">
			<p className="mb-3">
				The quickest way to delete your WholesaleDai account is from the mobile
				app:
			</p>
			<Bullets
				items={[
					"Open the WholesaleDai app and sign in.",
					"Go to the Profile tab.",
					"Scroll to the bottom and tap Delete Account.",
					"Confirm. Your account is deleted immediately.",
				]}
			/>
		</Section>

		<Section heading="If you cannot sign in">
			<p>
				If your account is still awaiting verification, or you have lost access
				to your phone number, email{" "}
				<a href="mailto:support@wholesaledai.com" className="text-brand-600 font-semibold underline">
					support@wholesaledai.com
				</a>{" "}
				from the address on your account, with the subject "Delete my account"
				and the phone number you registered with. We will verify that the
				request is genuinely yours and delete the account within 30 days.
			</p>
		</Section>

		<Section heading="What gets deleted">
			<p className="mb-3">Deleting your account erases:</p>
			<Bullets
				items={[
					"Your name, phone numbers and email address.",
					"Your PAN number, business registration document and identity document.",
					"Your profile photo and business address.",
					"The push notification tokens for your devices.",
				]}
			/>
			<p className="mt-3">
				You are signed out on every device immediately and cannot sign in
				again. To use WholesaleDai afterwards you would need to register a new
				account and be verified again.
			</p>
		</Section>

		<Section heading="What we keep, and why">
			<p>
				Records of orders you have already placed are retained after deletion,
				because tax and accounting rules require both us and the sellers you
				bought from to keep them. These records are no longer linked to your
				name, phone number, email address or documents.
			</p>
		</Section>

		<Section heading="Questions">
			<p>
				See our{" "}
				<Link to="/privacy" className="text-brand-600 font-semibold underline">
					privacy policy
				</Link>{" "}
				for the full picture, or contact{" "}
				<a href="mailto:support@wholesaledai.com" className="text-brand-600 font-semibold underline">
					support@wholesaledai.com
				</a>
				.
			</p>
		</Section>
	</LegalPage>
);

export default DeleteAccount;
